/* Social share row — ArtisanBox. Replaces Dawn share.js on product pages. */
if (!customElements.get('social-share')) {
  customElements.define('social-share', class SocialShare extends HTMLElement {
    connectedCallback() {
      this.url = this.dataset.url || document.location.href;
      this.shareTitle = this.dataset.title || document.title;
      this.media = this.dataset.media || '';
      this.status = this.querySelector('[data-share-status]');
      this.buildLinks();

      const copy = this.querySelector('[data-share-copy]');
      if (copy) copy.addEventListener('click', () => this.copyLink());

      if (navigator.share) {
        const nativeShare = () => navigator.share({ url: this.url, title: this.shareTitle }).catch(() => {});
        const native = this.querySelector('[data-share-native]');
        if (native) {
          native.hidden = false;
          native.addEventListener('click', nativeShare);
        }
        /* Mobile shortcut on the product photo (rendered in main-product) */
        const mediaBtn = this.id ? document.querySelector('[data-media-share="' + this.id + '"]') : null;
        if (mediaBtn) {
          mediaBtn.hidden = false;
          mediaBtn.addEventListener('click', nativeShare);
        }
      }
    }

    buildLinks() {
      const u = encodeURIComponent(this.url);
      const t = encodeURIComponent(this.shareTitle);
      const m = encodeURIComponent(this.media);
      const hrefs = {
        facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + u,
        x: 'https://x.com/intent/tweet?url=' + u + '&text=' + t,
        pinterest: 'https://pinterest.com/pin/create/button/?url=' + u + '&media=' + m + '&description=' + t,
        whatsapp: 'https://wa.me/?text=' + t + '%20' + u,
        email: 'mailto:?subject=' + t + '&body=' + t + '%0A' + u
      };
      this.querySelectorAll('[data-network]').forEach((a) => {
        const h = hrefs[a.dataset.network];
        if (h) a.href = h;
      });
    }

    copyLink() {
      const done = () => {
        if (!this.status) return;
        this.status.textContent = (window.accessibilityStrings && window.accessibilityStrings.shareSuccess) || 'Link copied';
        this.status.hidden = false;
        clearTimeout(this._t);
        this._t = setTimeout(() => { this.status.hidden = true; this.status.textContent = ''; }, 2500);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.url).then(done).catch(() => window.prompt('Copy this link', this.url));
      } else {
        window.prompt('Copy this link', this.url);
      }
    }

    /* Called by the theme when the variant changes */
    updateUrl(url) {
      this.url = url;
      this.buildLinks();
    }
  });
}